module.exports = __webpack_public_path__ + "tabs.52fb491ad01158689dd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabs.svg
// module id = ./src/assets/img/tabs.svg
// module chunks = main